(function () {
  'use strict';

  var MOBILE_BP = 768;

  var root = document.getElementById('metafield-filter-root');
  if (!root) return;

  var collectionHandle = root.dataset.collection;
  var totalCount       = parseInt(root.dataset.total, 10) || 0;
  var indexUrl         = root.dataset.indexUrl;

  // ── DOM targets ─────────────────────────────────────────────────────────────
  var sidebar      = document.getElementById('cloud_search_filters_sidebar');
  var productsList = document.getElementById('ProductsList');
  var countEl      = document.getElementById('ProductCount');

  if (!sidebar || !productsList) return;

  var originalProductsHtml = productsList.innerHTML;
  var originalCountText    = countEl ? countEl.textContent : '';

  // ── State ────────────────────────────────────────────────────────────────────
  var index           = null;
  var colHandles      = [];
  var activeFilters   = {};
  var page            = 0;
  var PAGE_SIZE       = 48;
  var filterContainer = sidebar; // sidebar on desktop, drawer body on mobile
  var nativeTotal     = totalCount;
  // True once collection-slider.js has switched the grid to a product set that
  // differs from the server-rendered collection (clearing filters must then
  // re-render that set rather than restore the original HTML).
  var overridden      = false;

  // ── Public API (used by collection-slider.js) ───────────────────────────────
  var api = window.MetafieldFilters = {
    ready: false,
    nativeTotal: function () { return nativeTotal; },

    // Union of the product handles in a collection and all its descendants.
    productsFor: function (handle, childMap) {
      var seen = {};
      var out  = [];
      (function walk(h, depth) {
        if (depth > 8) return;
        ((index && index.collections[h]) || []).forEach(function (p) {
          if (!seen[p]) { seen[p] = true; out.push(p); }
        });
        ((childMap && childMap[h]) || []).forEach(function (ch) { walk(ch, depth + 1); });
      })(handle, 0);
      return out;
    },

    // Swap the grid, filter sidebar and counts to the given product handles.
    showProducts: function (handles) {
      overridden    = true;
      colHandles    = handles;
      totalCount    = handles.length;
      activeFilters = {};
      page          = 0;

      var nativePagination = document.querySelector('#ProductGridContainer .pagination');
      if (nativePagination) nativePagination.style.display = 'none';
      var emptyState = document.querySelector('#ProductGridContainer .empty-state');
      if (emptyState) emptyState.style.display = 'none';

      if (filterContainer) filterContainer.innerHTML = '';
      renderSidebar();
      renderChips([]);
      updateMobileCount();
      loadPage(handles, 0);
    },
  };

  // ── Bootstrap ────────────────────────────────────────────────────────────────
  // Set up the UI shell immediately so the Filter button appears right away
  // on mobile — don't wait for the index fetch to finish.
  injectStyles();
  if (window.innerWidth < MOBILE_BP) {
    setupMobileUI();
  }

  fetch(indexUrl)
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (data) {
      index      = data;
      colHandles = data.collections[collectionHandle] || [];
      if (window.innerWidth >= MOBILE_BP) {
        constrainSidebar();
        filterContainer = sidebar;
      }
      renderSidebar();
      api.ready = true;
      document.dispatchEvent(new CustomEvent('mff:ready'));
    })
    .catch(function (err) {
      console.info('[MetafieldFilters] Index not available:', err.message);
    });

  // ── Mobile drawer ────────────────────────────────────────────────────────────
  function setupMobileUI() {
    // Always build our own button + drawer. Hide the theme's native filter
    // button so there is no duplicate.
    var nativeBtnWrap = document.querySelector('.facet-drawer-button-wrap');
    if (nativeBtnWrap) nativeBtnWrap.style.display = 'none';

    // ── Filter button ──
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id   = 'mff-mobile-btn';
    btn.className = 'mff-mobile-btn';
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"' +
        ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/>' +
        '<line x1="11" y1="18" x2="13" y2="18"/>' +
      '</svg>' +
      ' Filter' +
      '<span id="mff-mobile-count" class="mff-mobile-count" style="display:none"></span>';
    btn.addEventListener('click', openMobileDrawer);

    // Insert the button into the toolbar-left div so it appears alongside
    // the product count. Fall back to right before the product list.
    var inserted = false;
    if (countEl) {
      var toolbarLeft = countEl.closest('.collection__toolbar-left');
      if (toolbarLeft) {
        toolbarLeft.insertBefore(btn, toolbarLeft.firstChild);
        inserted = true;
      }
    }
    if (!inserted) {
      productsList.parentElement.insertBefore(btn, productsList);
    }

    // ── Backdrop ──
    var backdrop = document.createElement('div');
    backdrop.id = 'mff-backdrop';
    backdrop.className = 'mff-backdrop';
    backdrop.addEventListener('click', closeMobileDrawer);
    document.body.appendChild(backdrop);

    // ── Drawer panel ──
    var drawer = document.createElement('div');
    drawer.id = 'mff-drawer';
    drawer.className = 'mff-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Filter products');
    drawer.innerHTML =
      '<div class="mff-drawer__head">' +
        '<span class="mff-drawer__title">Filter</span>' +
        '<button type="button" class="mff-drawer__close" aria-label="Close filters">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"' +
            ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="mff-drawer__body" id="mff-drawer-body">' +
        '<p class="mff-loading">Loading filters…</p>' +
      '</div>' +
      '<div class="mff-drawer__foot">' +
        '<button type="button" class="mff-drawer__apply" onclick="document.getElementById(\'mff-drawer\').classList.remove(\'mff-drawer--open\');document.getElementById(\'mff-backdrop\').classList.remove(\'mff-backdrop--open\');document.body.style.overflow=\'\'">Apply</button>' +
      '</div>';

    drawer.querySelector('.mff-drawer__close').addEventListener('click', closeMobileDrawer);
    document.body.appendChild(drawer);

    filterContainer = document.getElementById('mff-drawer-body');
  }

  function openMobileDrawer() {
    document.getElementById('mff-backdrop').classList.add('mff-backdrop--open');
    document.getElementById('mff-drawer').classList.add('mff-drawer--open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileDrawer() {
    document.getElementById('mff-backdrop').classList.remove('mff-backdrop--open');
    document.getElementById('mff-drawer').classList.remove('mff-drawer--open');
    document.body.style.overflow = '';
  }

  function updateMobileCount() {
    var badge = document.getElementById('mff-mobile-count');
    if (!badge) return;
    var total = 0;
    Object.values(activeFilters).forEach(function (s) { total += s.size; });
    badge.textContent = total;
    badge.style.display = total > 0 ? '' : 'none';
  }

  // ── Desktop sticky sidebar ───────────────────────────────────────────────────
  function constrainSidebar() {
    if (!sidebar) return;
    sidebar.style.maxHeight = 'calc(100vh - 9rem)';
    sidebar.style.overflowY = 'auto';
    sidebar.style.overflowX = 'hidden';
    var wrap = sidebar.closest('.sticky-element');
    if (wrap) {
      wrap.style.position = 'sticky';
      wrap.style.top      = 'var(--sticky-offset, 7.2rem)';
      wrap.style.zIndex   = '8';
    }
  }

  // ── Sidebar / drawer rendering ───────────────────────────────────────────────
  function renderSidebar() {
    var container = filterContainer;
    if (!container) return;
    var groups = buildGroups();
    if (!groups.length) return;

    container.innerHTML = '';

    groups.forEach(function (group) {
      var section = document.createElement('div');
      section.className = 'mff-group';

      var btn = document.createElement('button');
      btn.className = 'mff-group__header';
      btn.type = 'button';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML =
        '<span class="mff-group__name">' + esc(group.name) + '</span>' +
        '<span class="mff-group__arrow" aria-hidden="true"></span>';
      btn.addEventListener('click', function () { toggleGroup(section, btn); });

      var body = document.createElement('div');
      body.className = 'mff-group__body';
      body.style.display   = 'none';
      body.style.maxHeight = '200px';
      body.style.overflowY = 'auto';

      var entries = Object.entries(group.valueCounts);
      entries.sort(function (a, b) {
        var aVal = measureSort(a[0]);
        var bVal = measureSort(b[0]);
        if (!isNaN(aVal) && !isNaN(bVal)) return aVal - bVal;
        if (!isNaN(aVal)) return -1;
        if (!isNaN(bVal)) return 1;
        return a[0].localeCompare(b[0], undefined, { numeric: true, sensitivity: 'base' });
      });

      entries.forEach(function (entry) {
        var value  = entry[0];
        var count  = entry[1];
        var safeId = 'mff-' + group.key.replace(/[^a-z0-9]/gi, '_') + '-' + value.replace(/[^a-z0-9]/gi, '_');

        var label = document.createElement('label');
        label.className = 'mff-option';
        label.setAttribute('for', safeId);

        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.id   = safeId;
        cb.className   = 'mff-checkbox';
        cb.dataset.key   = group.key;
        cb.dataset.value = value;
        // Restore checked state if filter already active
        if (activeFilters[group.key] && activeFilters[group.key].has(value)) cb.checked = true;
        cb.addEventListener('change', onFilterChange);

        label.appendChild(cb);
        label.insertAdjacentHTML(
          'beforeend',
          '<span class="mff-option__label">' + esc(value) + '</span>' +
          '<span class="mff-option__count">(' + count + ')</span>'
        );
        body.appendChild(label);
      });

      section.appendChild(btn);
      section.appendChild(body);
      container.appendChild(section);
    });
  }

  function buildGroups() {
    if (!index) return [];
    return index.filterDefs
      .map(function (def) {
        var valueCounts = countForGroup(def.key);
        return { key: def.key, name: def.name, valueCounts: valueCounts };
      })
      .filter(function (g) { return Object.keys(g.valueCounts).length > 0; });
  }

  // Count values for one filter group using products that match all OTHER active filters.
  // This gives conjunctive counts — selecting M8-1.25 narrows the wrench-size counts accordingly.
  function countForGroup(key) {
    var otherKeys = Object.keys(activeFilters).filter(function (k) { return k !== key; });
    var base = otherKeys.length === 0 ? colHandles : colHandles.filter(function (handle) {
      var p = index.products[handle];
      if (!p) return false;
      return otherKeys.every(function (k) {
        var selected = activeFilters[k];
        var raw = p[k];
        if (raw == null || raw === '') return false;
        return parseValue(raw).some(function (v) { return selected.has(v); });
      });
    });
    var counts = {};
    base.forEach(function (handle) {
      var p = index.products[handle];
      if (!p) return;
      var raw = p[key];
      if (raw == null || raw === '') return;
      parseValue(raw).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
    });
    return counts;
  }

  // Update count labels in-place without collapsing the sidebar groups.
  function updateSidebarCounts() {
    if (!index) return;
    index.filterDefs.forEach(function (def) {
      var counts = countForGroup(def.key);
      filterContainer.querySelectorAll('input.mff-checkbox[data-key="' + def.key + '"]').forEach(function (cb) {
        var count = counts[cb.dataset.value] || 0;
        var option = cb.closest('.mff-option');
        if (!option) return;
        var countEl = option.querySelector('.mff-option__count');
        if (countEl) countEl.textContent = '(' + count + ')';
        option.style.opacity = count === 0 ? '0.4' : '';
      });
    });
  }

  function toggleGroup(section, btn) {
    var body     = section.querySelector('.mff-group__body');
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    body.style.display = expanded ? 'none' : '';
  }

  // ── Filter logic ─────────────────────────────────────────────────────────────
  function onFilterChange(e) {
    var key   = e.target.dataset.key;
    var value = e.target.dataset.value;
    if (!activeFilters[key]) activeFilters[key] = new Set();
    if (e.target.checked) {
      activeFilters[key].add(value);
    } else {
      activeFilters[key].delete(value);
      if (activeFilters[key].size === 0) delete activeFilters[key];
    }
    page = 0;
    updateMobileCount();
    applyFilters();
  }

  function applyFilters() {
    var keys = Object.keys(activeFilters);
    var nativePagination = document.querySelector('#ProductGridContainer .pagination');

    if (keys.length === 0 && overridden) {
      renderChips([]);
      updateSidebarCounts();
      loadPage(colHandles, 0);
      return;
    }

    if (keys.length === 0) {
      productsList.innerHTML = originalProductsHtml;
      if (countEl) countEl.textContent = originalCountText;
      renderChips([]);
      // Restore native pagination and reset sidebar counts to full collection
      if (nativePagination) nativePagination.style.display = '';
      updateSidebarCounts();
      return;
    }

    // Hide native Shopify page-number pagination — the custom filter uses
    // its own load-more button and native pages no longer reflect filtered count.
    if (nativePagination) nativePagination.style.display = 'none';

    var matching = colHandles.filter(function (handle) {
      var p = index.products[handle];
      if (!p) return false;
      return keys.every(function (key) {
        var selected = activeFilters[key];
        var raw      = p[key];
        if (raw == null || raw === '') return false;
        return parseValue(raw).some(function (v) { return selected.has(v); });
      });
    });

    renderChips(keys);
    updateSidebarCounts();
    loadPage(matching, 0);
  }

  // ── Product grid ─────────────────────────────────────────────────────────────
  function loadPage(handles, pageNum) {
    var slice  = handles.slice(pageNum * PAGE_SIZE, (pageNum + 1) * PAGE_SIZE);
    var isFirst = pageNum === 0;

    if (isFirst) {
      if (countEl) countEl.textContent = handles.length + ' of ' + totalCount + ' products';
      productsList.innerHTML = '<div class="mff-loading">Loading…</div>';
      if (handles.length === 0) {
        productsList.innerHTML = '<div class="mff-loading" style="grid-column:1/-1;">No products found.</div>';
        return;
      }
    }

    fetchProducts(slice).then(function (products) {
      if (isFirst) {
        productsList.innerHTML = products.map(productCard).join('');
      } else {
        var spinner = productsList.querySelector('.mff-load-more-wrap');
        if (spinner) spinner.remove();
        products.forEach(function (p) {
          productsList.insertAdjacentHTML('beforeend', productCard(p));
        });
      }

      var hasMore = (pageNum + 1) * PAGE_SIZE < handles.length;
      if (hasMore) {
        var nextPage = pageNum + 1;
        productsList.insertAdjacentHTML(
          'beforeend',
          '<div class="mff-load-more-wrap f-column" style="grid-column:1/-1;text-align:center;padding:16px 0;">' +
          '<button class="btn btn--secondary mff-load-more" type="button">' +
          'Show more (' + (handles.length - (nextPage * PAGE_SIZE)) + ' remaining)</button></div>'
        );
        productsList.querySelector('.mff-load-more').addEventListener('click', function () {
          loadPage(handles, nextPage);
        });
      }
    });
  }

  function fetchProducts(handles) {
    var BATCH = 10;
    var batches = [];
    for (var i = 0; i < handles.length; i += BATCH) {
      batches.push(handles.slice(i, i + BATCH));
    }
    return batches.reduce(function (chain, batch) {
      return chain.then(function (acc) {
        return Promise.all(
          batch.map(function (h) {
            return fetch('/products/' + h + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          })
        ).then(function (results) {
          return acc.concat(results.filter(Boolean));
        });
      });
    }, Promise.resolve([]));
  }

  function productCard(p) {
    var src = '';
    if (p.featured_image) {
      src = (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || '');
      src = src.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2');
    }

    var price       = money(p.price);
    var compareAt   = p.compare_at_price > p.price ? money(p.compare_at_price) : null;
    var saleBadge   = compareAt ? '<div class="mff-badge" aria-label="Sale">Sale</div>' : '';
    var priceHtml   = compareAt
      ? '<span class="mff-price mff-price--sale">' + price + '</span> <s class="mff-price mff-price--compare">' + compareAt + '</s>'
      : '<span class="mff-price">' + price + '</span>';
    var imgHtml = src
      ? '<img src="' + src + '" alt="' + esc(p.title) + '" loading="lazy" class="mff-card__img">'
      : '<div class="mff-card__img mff-card__img--placeholder"></div>';

    return (
      '<div class="f-column product-column">' +
        '<div class="card-product card-product--standard mff-card">' +
          '<div class="card-product__media mff-card__media">' +
            saleBadge +
            '<a href="' + p.url + '" class="media media--image mff-card__media-link" tabindex="-1" aria-hidden="true">' +
              imgHtml +
            '</a>' +
          '</div>' +
          '<div class="card-product__info mff-card__info">' +
            '<a class="card-product__title mff-card__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
            '<div class="price">' + priceHtml + '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  // ── Active filter chips ───────────────────────────────────────────────────────
  function renderChips(activeKeys) {
    var container = document.getElementById('mff-chips');
    if (!container) {
      container = document.createElement('div');
      container.id = 'mff-chips';
      container.className = 'mff-chips';
      productsList.parentElement.insertBefore(container, productsList);
    }

    if (!activeKeys.length) {
      container.innerHTML = '';
      return;
    }

    var chips = [];
    activeKeys.forEach(function (key) {
      var def = (index.filterDefs || []).find(function (d) { return d.key === key; });
      var label = def ? def.name : key;
      activeFilters[key].forEach(function (val) {
        chips.push(
          '<button class="mff-chip" type="button" data-key="' + esc(key) + '" data-value="' + esc(val) + '">' +
            '<span>' + esc(label) + ': ' + esc(val) + '</span>' +
            '<span class="mff-chip__x" aria-hidden="true">&times;</span>' +
          '</button>'
        );
      });
    });
    chips.push('<button id="mff-clear-all" class="mff-clear-all" type="button">Clear all</button>');
    container.innerHTML = chips.join('');

    container.querySelectorAll('.mff-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var key = chip.dataset.key;
        var val = chip.dataset.value;
        if (activeFilters[key]) {
          activeFilters[key].delete(val);
          if (activeFilters[key].size === 0) delete activeFilters[key];
        }
        // Uncheck the matching checkbox wherever it lives (sidebar or drawer)
        var cb = filterContainer.querySelector(
          'input.mff-checkbox[data-key="' + key + '"][data-value="' + val + '"]'
        );
        if (cb) cb.checked = false;
        page = 0;
        updateMobileCount();
        applyFilters();
      });
    });

    var clearBtn = document.getElementById('mff-clear-all');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        activeFilters = {};
        filterContainer.querySelectorAll('input.mff-checkbox').forEach(function (cb) { cb.checked = false; });
        page = 0;
        updateMobileCount();
        applyFilters();
      });
    }
  }

  // ── Utilities ─────────────────────────────────────────────────────────────────

  function measureSort(str) {
    var s = String(str).trim();

    // Metric: M6, M10, M12-1.75, M8×1.25
    var m = s.match(/^[Mm](\d+(?:\.\d+)?)(?:[-×x](\d+(?:\.\d+)?))?/);
    if (m) {
      var diameter = parseFloat(m[1]);
      var pitch    = m[2] ? parseFloat(m[2]) : 0;
      return diameter + pitch / 10000;
    }

    // Fractional inch with whole-number prefix: 1-1/4, 1-1/2
    m = s.match(/^(\d+)-(\d+)\/(\d+)/);
    if (m) return parseInt(m[1], 10) + parseInt(m[2], 10) / parseInt(m[3], 10);

    // Simple fraction: 1/4, 3/8, 5/16
    m = s.match(/^(\d+)\/(\d+)/);
    if (m) return parseInt(m[1], 10) / parseInt(m[2], 10);

    // #-size: #4, #6, #8, #10
    m = s.match(/^#(\d+)/);
    if (m) return parseInt(m[1], 10);

    // Class or Grade with a number
    m = s.match(/(?:[Cc]lass|[Gg]rade)\s+(\d+(?:\.\d+)?)/);
    if (m) return parseFloat(m[1]);

    // Plain number or number with unit suffix
    m = s.match(/^(\d+(?:\.\d+)?)\s*(?:mm|cm|m|in|ft|"|')?/i);
    if (m) return parseFloat(m[1]);

    return NaN;
  }

  function parseValue(raw) {
    if (typeof raw !== 'string') return [String(raw)];
    var t = raw.trim();
    if (t.charAt(0) === '[') {
      try { return JSON.parse(t).map(String); } catch (_) { /* fall through */ }
    }
    return [t];
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ── Styles ────────────────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('mff-css')) return;
    var s = document.createElement('style');
    s.id  = 'mff-css';
    s.textContent = [
      /* Hide the Cloud Search app's own auto-generated filter accordion —
         it renders into the same #cloud_search_filters_sidebar container
         asynchronously, after we've already populated it with .mff-group
         filters, producing duplicate filter lists. */
      '#cloud_search_filters_sidebar .cloud-search-filters-sidebar { display: none !important; }',
      /* Filter groups */
      '.mff-group { border-bottom: 1px solid var(--color-border, #e5e5e5); padding: 10px 0; }',
      '.mff-group__header { width:100%; display:flex; justify-content:space-between; align-items:center;',
        'background:none; border:none; padding:6px 0; cursor:pointer;',
        'font-size:1.3rem; font-weight:700; text-transform:uppercase; letter-spacing:.06em;',
        'color:inherit; }',
      '.mff-group__header:hover { opacity:.8; }',
      '.mff-group__arrow { width:10px; height:10px; border-right:2px solid currentColor;',
        'border-bottom:2px solid currentColor; transform:rotate(-135deg); transition:transform .2s;',
        'margin-right:2px; flex-shrink:0; }',
      '[aria-expanded="false"] .mff-group__arrow { transform:rotate(45deg); }',
      '.mff-group__body { padding:6px 0 4px; }',

      /* Filter options */
      '.mff-option { display:flex; align-items:center; gap:8px; padding:6px 2px; cursor:pointer;',
        'font-size:1.4rem; line-height:1.3; }',
      '.mff-option:hover .mff-option__label { color: var(--color-primary, #033f77); }',
      '.mff-checkbox { width:18px; height:18px; flex-shrink:0; cursor:pointer;',
        'accent-color: var(--color-primary, #033f77); }',
      '.mff-option__count { margin-left:auto; color: var(--color-subtext, #666); font-size:1.2rem; padding-left:4px; }',

      /* Active chips */
      '.mff-chips { display:flex; flex-wrap:wrap; gap:8px; margin-bottom:12px; }',
      '.mff-chip { display:inline-flex; align-items:center; gap:5px; padding:5px 12px;',
        'border:1px solid #ccc; border-radius:20px; background:#fff; cursor:pointer;',
        'font-size:.875rem; transition:background .15s; }',
      '.mff-chip:hover { background:#f5f5f5; }',
      '.mff-chip__x { font-size:1rem; line-height:1; color:#888; }',
      '.mff-clear-all { background:none; border:none; cursor:pointer;',
        'font-size:.875rem; text-decoration:underline; padding:4px 2px; }',

      /* Loading */
      '.mff-loading { padding:2rem; text-align:center; color: var(--color-subtext, #666); font-size:.875rem; }',

      /* Product card overrides */
      '.mff-card { height:100%; }',
      '.mff-card__media { position:relative; overflow:hidden; border-radius: var(--pcard-radius, 0); }',
      '.mff-card__media-link { display:block; aspect-ratio:1; }',
      '.mff-card__img { width:100%; height:100%; object-fit:contain; display:block; }',
      '.mff-card__img--placeholder { width:100%; height:100%; background:#f5f5f5; }',
      '.mff-badge { position:absolute; top:8px; left:8px; z-index:1;',
        'background: var(--color-accent, #c4301c); color:#fff;',
        'padding:2px 8px; font-size:.7rem; font-weight:700;',
        'border-radius:3px; text-transform:uppercase; letter-spacing:.04em; }',
      '.mff-card__info { padding:10px 2px 4px; }',
      '.mff-card__title { display:block; line-height:1.3;',
        'margin-bottom:4px; color:inherit; text-decoration:none; }',
      '.mff-card__title:hover { text-decoration:underline; }',
      '.mff-price--sale { color: var(--color-accent, #c4301c); font-weight:700; }',
      '.mff-price--compare { color: var(--color-subtext, #999); }',
      '.mff-load-more-wrap { display:flex; justify-content:center; }',

      /* ── Mobile filter button ── */
      '.mff-mobile-btn { display:none; align-items:center; gap:8px; padding:8px 16px;',
        'border:1px solid #aaa; border-radius:6px;',
        'background:#fff; color:#111 !important; cursor:pointer; font-size:.875rem; font-weight:600;',
        'margin-bottom:12px; }',
      '.mff-mobile-btn svg { stroke:#111 !important; }',
      '.mff-mobile-btn:hover { background:#f3f3f3; }',
      '.mff-mobile-count { display:inline-flex; align-items:center; justify-content:center;',
        'min-width:18px; height:18px; padding:0 5px; border-radius:9px;',
        'background: var(--color-primary, #033f77); color:#fff;',
        'font-size:.7rem; font-weight:700; }',
      '@media (max-width:' + (MOBILE_BP - 1) + 'px) {',
        '.mff-mobile-btn { display:flex; }',
      '}',

      /* ── Mobile backdrop ── */
      '.mff-backdrop { display:none; position:fixed; inset:0; background:rgba(0,0,0,.5); z-index:200;',
        'opacity:0; transition:opacity .25s; }',
      '.mff-backdrop--open { display:block; opacity:1; }',

      /* ── Mobile drawer ── */
      '.mff-drawer { position:fixed; top:0; left:0; bottom:0; width:85vw; max-width:340px;',
        'background:#fff; color:#111; z-index:201; display:flex; flex-direction:column;',
        'transform:translateX(-100%); transition:transform .28s ease; }',
      '.mff-drawer--open { transform:translateX(0); }',
      '.mff-drawer__head { display:flex; align-items:center; justify-content:space-between;',
        'padding:16px; border-bottom:1px solid #e5e5e5; flex-shrink:0;',
        'background:#fff; color:#111; }',
      '.mff-drawer__title { font-size:1rem; font-weight:700; text-transform:uppercase;',
        'letter-spacing:.06em; color:#111; }',
      '.mff-drawer__close { background:none; border:none; cursor:pointer; padding:4px;',
        'color:#111; line-height:1; }',
      '.mff-drawer__close:hover { opacity:.7; }',
      '.mff-drawer__body { flex:1; overflow-y:auto; padding:0 16px;',
        'background:#fff; color:#111; }',
      '.mff-drawer__foot { flex-shrink:0; padding:12px 16px;',
        'border-top:1px solid #e5e5e5; background:#fff; }',
      '.mff-drawer__apply { width:100%; padding:12px; border:none; border-radius:6px;',
        'background: var(--color-primary, #033f77); color:#fff !important;',
        'font-size:.9375rem; font-weight:700; cursor:pointer; }',
      '.mff-drawer__apply:hover { opacity:.9; }',
      /* Force all text inside the drawer to be dark regardless of theme inheritance */
      '.mff-drawer .mff-group__header { color:#111; }',
      '.mff-drawer .mff-option { color:#111; }',
      '.mff-drawer .mff-option__count { color:#555; }',
      '.mff-drawer .mff-loading { color:#555; }',
    ].join(' ');
    document.head.appendChild(s);
  }
})();
